// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__v65Ka","author":"Table_author__3KKBD","authorImage":"Table_authorImage__28fZn","unreadRow":"Table_unreadRow__1V8e8"};